import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:8080/reg",
  baseURL: window.location.origin + "/reg",
  headers: {
    "Content-type": "application/json"
  }
});